import { GameDayModel } from '../../../models/gameday-model';
import { GamedayState } from '../../../state/data/state';
import {
  searchByManagerAccount,
  ACCOUNT
} from '../../../gameday/data/gameDay-data.calculation';
import {
  flattenTo,
  getSegments as dataGetSegment,
  OrdersSegment
} from '../../../gameday/data/gameDay-data.segmentations';
import { segmentsExtractors } from '../../../gameday/mappers/gameDay.extractors';
import { SummaryBar } from './order-summary-bar-chart.component';

export function getData({
  data: { deal, orders },
  activeAccount
}: {
  data: GamedayState;
  activeAccount: string;
}): GameDayModel.RawData {
  return searchByManagerAccount(
    { deal, orders },
    {
      name: activeAccount,
      type: ACCOUNT
    }
  );
}

export function getSegments({
  deal: { maturities },
  orders
}: GameDayModel.RawData): OrdersSegment<any>[] {
  return flattenTo(dataGetSegment(orders, maturities, segmentsExtractors));
}

export function getBars(
  segments: OrdersSegment<any>[],
  highlightMaturityId: string
): SummaryBar[] {
  return segments.map(({ maturities, orders, id }) => ({
    size: maturities.reduce(
      (prev: number, maturity: GameDayModel.Maturity) => prev + maturity.size,
      0
    ),
    value: orders.reduce(
      (prev, order: GameDayModel.Order) => prev + order.amount,
      0
    ),
    id,
    highlighted: maturities.some(
      maturity => maturity.id === highlightMaturityId
    )
  }));
}
